// extracted by mini-css-extract-plugin
export default {"-large":"LDRqBPMcIsDaY8gz2T9h","container":"Dso2JqlrRERa52ECRRJb","content":"QcdgCyhsqlsVEvsUza4P"};